import React from 'react';
import { Box } from '@mui/material';

import Text from 'components/text';

import { FONT } from '../constants';

// Form field label shared by the Collab Club admin modals; renders an optional
// red asterisk for required fields.
const FieldLabel: React.FC<{ children: React.ReactNode; required?: boolean }> = ({
  children,
  required,
}) => (
  <Text fontSize={FONT.sm} fontWeight={500} color="#0f172a" marginBottom="6px">
    {children}
    {required && (
      <Box component="span" color="#dc2626" marginLeft="2px">
        *
      </Box>
    )}
  </Text>
);

export default FieldLabel;
